import ApplicationController from "./application_controller";

// Attached to the admin action toolbar in account_s_domains_list.
export default class TlsBulkActionsController extends ApplicationController {

  refreshTlsDomainsWithIssues(event) {
    if (!confirm('Refresh TLS status from Mailgun for domains that have TLS issues only (errors, unknown, expired, or missing TLS row). Continue?')) {
      return;
    }

    const btn      = event.currentTarget;
    const origHtml = btn.innerHTML;
    this.setLoading(btn, '<i class="fas fa-spinner fa-spin me-2"></i> Starting...');

    $.ajax({
      url:     '/mailgun/domains/tls/refresh_tls_domains_with_issues',
      method:  'POST',
      dataType: 'json',
      data:    { account_id: this.accountId },
      headers: { 'X-CSRF-Token': this.csrfToken() },
      success: (response) => {
        const type = response.success ? 'success' : 'error';
        alertCustom(response.message, { alertType: type, displayPlacement: 'hover', icon: response.success ? 'check' : 'error' });
      },
      error: (xhr) => {
        const errorMsg = xhr.responseJSON?.message || 'Could not start TLS refresh for domains with issues';
        alertCustom(errorMsg, { alertType: 'error', displayPlacement: 'hover', icon: 'error' });
      },
      complete: () => this.restoreButton(btn, origHtml)
    });
  }

  refreshTlsAllDomains(event) {
    if (!confirm('Refresh TLS status from Mailgun for every domain in this account. This may take a while. Continue?')) {
      return;
    }

    const btn      = event.currentTarget;
    const origHtml = btn.innerHTML;
    this.setLoading(btn, '<i class="fas fa-spinner fa-spin me-2"></i> Starting...');

    $.ajax({
      url:     '/mailgun/domains/tls/refresh_tls_all_domains',
      method:  'POST',
      dataType: 'json',
      data:    { account_id: this.accountId },
      headers: { 'X-CSRF-Token': this.csrfToken() },
      success: (response) => {
        const type = response.success ? 'success' : 'error';
        alertCustom(response.message, { alertType: type, displayPlacement: 'hover', icon: response.success ? 'check' : 'error' });
      },
      error: (xhr) => {
        const errorMsg = xhr.responseJSON?.message || 'Could not start TLS refresh for all domains';
        alertCustom(errorMsg, { alertType: 'error', displayPlacement: 'hover', icon: 'error' });
      },
      complete: () => this.restoreButton(btn, origHtml)
    });
  }

  get accountId() { return this.element.dataset.accountId; }

  setLoading(btn, html) {
    btn.disabled  = true;
    btn.innerHTML = html;
  }

  restoreButton(btn, html) {
    btn.disabled  = false;
    btn.innerHTML = html;
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content;
  }
}
